'use es6';

import Context from 'cookie-banner/utils/context';
import { endsWith } from 'cookie-banner/utils/hspbUtils';
const encodeParam = param => encodeURI(param);
const decodeParam = param => decodeURI(param);
const REMOVE_COOKIE_EXPIRY = '1970-01-01T00:00:01-00:00';
export default class Cookie {
  constructor(context) {
    this.context = context || new Context();
    this.currentDomain = null;
    this.cookiesToSubdomain = false;
    this.useSecureCookies = false;
    this.domains = [];
  }
  isEnabled() {
    const cookieEnabled = this.context.getNavigator().cookieEnabled;
    return cookieEnabled || 'cookie' in this.context.getDocument() && this.context.getDocument().cookie.length > 0;
  }
  addDomain(domain) {
    const dotHostName = `.${this.context.getHostName()}`;
    if (endsWith(dotHostName, domain) && (!this.currentDomain || domain.length < this.currentDomain.length)) {
      this.currentDomain = domain;
    }
    this.domains.push(domain);
  }
  getDomains() {
    return this.domains;
  }
  get(cookieName) {
    const cookiePattern = new RegExp(`(^|;)[ ]*${cookieName}=([^;]*)`);
    const cookieMatch = cookiePattern.exec(this.context.getDocument().cookie);
    return cookieMatch ? decodeParam(cookieMatch[2]) : '';
  }
  set(cookieName, value, options) {
    options = options || {};
    let expiryTime;
    let expiryFormatted;
    let hasExpiration = false;
    if (options.minsToExpire) {
      expiryTime = new Date();
      expiryTime.setTime(expiryTime.getTime() + options.minsToExpire * 1000 * 60);
    } else if (options.daysToExpire) {
      expiryTime = new Date();
      expiryTime.setTime(expiryTime.getTime() + options.daysToExpire * 1000 * 60 * 60 * 24);
    } else if (options.expiryDate && options.expiryDate.toGMTString) {
      expiryTime = options.expiryDate;
    } else if (options.expiryDate) {
      expiryTime = new Date(options.expiryDate);
    }
    if (expiryTime !== undefined) {
      expiryFormatted = expiryTime.toGMTString();
      hasExpiration = true;
    }
    this.setCookie(cookieName, encodeParam(value), {
      expires: hasExpiration ? `;expires=${expiryFormatted}` : '',
      expiresTime: hasExpiration ? expiryTime : null,
      path: `;path=${options.path ? options.path : '/'}`,
      domain: !this.cookiesToSubdomain && this.currentDomain ? `;domain=${this.currentDomain}` : '',
      secure: this.useSecureCookies ? ';secure' : '',
      sameSite: this.useSecureCookies ? ';SameSite=None' : ';SameSite=Lax'
    });
  }

  //getDomainAncestry is required because _fbp may be place at any level of the domain
  //because we do not know where we must try to remove it at all levels.
  getDomainAncestry(domain) {
    if (domain === '' || !domain) {
      return [];
    }
    const domainLevels = domain.split('.');

    //if domain looks like domain.com
    if (domainLevels.length === 2) {
      return [domain];
    }

    // domain = domain.com. || .com
    if (domainLevels[domainLevels.length - 1] === '' || domainLevels.length < 2) {
      console.error(`Invalid Domain: ${domain}, Parsed As: [${domainLevels}]`);
      return [];
    }
    const domainAncestry = [];
    let i;
    let domainAggregate = `${domainLevels[domainLevels.length - 1]}`;
    //start at -2 to exclude .com domain
    for (i = domainLevels.length - 2; i >= 0; i--) {
      if (domainLevels[i] === '') {
        if (i !== 0) {
          // domain = this..my.com
          console.error(`Invalid Domain: ${domain}, Parsed As: [${domainLevels}]`);
          return [];
        }
        continue;
      }
      const subDomain = `${domainLevels[i]}.${domainAggregate}`;
      domainAncestry.push(subDomain);
      domainAggregate = subDomain;
    }
    return domainAncestry;
  }
  removeFBPCookie(cookieName) {
    const expiryTime = new Date(REMOVE_COOKIE_EXPIRY);
    const expiryFormatted = expiryTime.toGMTString();
    const domainAncestry = this.getDomainAncestry(this.context.getDocument().domain);
    domainAncestry.forEach(domain => {
      this.setCookie(cookieName, '', {
        expires: `;expires=${expiryFormatted}`,
        expiresTime: expiryTime,
        path: ';path=/',
        domain: `;domain=.${domain}`,
        secure: '',
        sameSite: ';SameSite=Lax'
      });
    });
  }
  remove(cookieName) {
    this.set(cookieName, '', {
      expiryDate: REMOVE_COOKIE_EXPIRY
    });
  }
  setCookie(name, value, options) {
    const extras = options.expires + options.path + options.domain + options.sameSite + options.secure;
    this.writeCookie(`${name}=${value}${extras}`);
    const cookie = this.get(name);
    if ((!cookie || cookie !== value) && options.domain !== '' && (!options.expiresTime || options.expiresTime - new Date() > 0)) {
      const newExtras = options.expires + options.path + options.sameSite + options.secure;
      this.writeCookie(`${name}=${value}${newExtras}`);
    }
  }
  writeCookie(cookie) {
    this.context.getDocument().cookie = cookie;
  }
  setCookiesToSubdomain(cookiesToSubdomain) {
    this.cookiesToSubdomain = cookiesToSubdomain;
  }
  setUseSecureCookies(useSecureCookies) {
    this.useSecureCookies = useSecureCookies;
  }
}